"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { Blobbie } from "../../ConnectWallet/Blobbie.js";
import { useAccountContext } from "./provider.js";
/**
 * A wrapper for the Blobbie component
 * @param props BlobbieProps
 * @beta
 * @wallet
 */
export function AccountBlobbie(props) {
    const { address } = useAccountContext();
    return _jsx(Blobbie, { ...props, address: address });
}
//# sourceMappingURL=blobbie.js.map